module.exports = __webpack_public_path__ + "img/jeet11.6bc5858e.png";